export const lastResourceNameUsage = (resources, name) => (
  resources
    ?.map((res) => Number(res.name.toLowerCase().match(
      new RegExp(name.toLowerCase() + " ?(\\d*)")
    )?.[1]))
    .filter(n => !isNaN(n))
    .sort((a, b) => (a > b ? -1 : 1))[0]
)